<label *ngIf="label">{{ label }}<span class="red" *ngIf="requiredMark">*</span></label>
<select
  [disabled]="disabled"
  class="custom-select {{ inputClasses }}"
  *ngIf="processedOptions && !loading"
  [(ngModel)]="model"
  (change)="setValue(model)"
  [ngClass]="{ 'is-invalid': hasValidationError() }"
>
  <option *ngIf="placeholder" [disabled]="disableDefault" [value]="null">{{ placeholder }}</option>
  <!-- fix empty option when value is not in options -->
  <option *ngIf="acceptOutsideList && !options.includes(model)" [disabled]="true" [value]="model">{{ model }}</option>
  <!-- With groups -->
  <ng-container *ngIf="hasCategories">
    <ng-container *ngFor="let group of processedOptions; let i = index">
      <!-- loose items -->
       <option *ngIf="group.grouplessOption" [disabled]="disableOtherOptions && group.label !== model" [value]="group.label">
        {{ group.label }}
       </option>
      <!-- catergories -->
      <optgroup label="{{ group.label }}" *ngIf="group?.children?.length">
        <option *ngFor="let option of group.children; let ii = index" [disabled]="disableOtherOptions && option !== model"
        [value]="option?.value || option"
        >
          {{ option?.label || option }}
          <span *ngIf="group.children[ii].extraInfo">{{ group.children[ii].extraInfo }}</span>
          <span *ngIf="disableOtherOptions && option !== model">(PRO)</span>
        </option>
      </optgroup>
    </ng-container>
  </ng-container>
  <!-- without Groups -->
  <ng-container *ngIf="!hasCategories">
    <ng-container *ngFor="let option of processedOptions; let i = index">
      <option [disabled]="disableOtherOptions && option !== model" [value]="option">
        {{ option }}
        <span *ngIf="options[i]?.extraInfo">{{ options[i].extraInfo }}</span>
        <span *ngIf="disableOtherOptions && option !== model">(PRO)</span>
      </option>
    </ng-container>
  </ng-container>
</select>

<div class="invalid-feedback" *ngIf="hasValidationError()">
  {{ invalidMsg }}
</div>
